import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/compat/database';
import { UserState } from '@client/utils/shared-constants';
import { EMPTY, Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

@Injectable()
export class UserService {
	itemsRef: AngularFireList<UserState> | Observable<never>;

	constructor(private db: AngularFireDatabase, private auth: AngularFireAuth) {
		auth.authState
			.pipe(
				tap(u => {
					this.itemsRef = u ? this.db.list<UserState>(`/user/${u.uid}`) : EMPTY;
				})
			)
			.subscribe();
	}

	delete() {
		return this.auth.user.pipe(
			take(1),
			switchMap(u => u.delete())
		);
	}

	hydrate() {
		return this.auth.user.pipe(switchMap(u => (u ? this.db.object<UserState>(`/user/${u.uid}`).valueChanges() : EMPTY)));
	}
}
